import { style } from '@vanilla-extract/css'
import path from './images/path.svg'

const section = style({
  background: 'linear-gradient(180.01deg, #F1EAEB 40.8%, #F2F1EF 99.99%)',
  paddingBottom: '64px',
})

const content = style({
  backgroundImage: `url("${path}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '40% 48%',
  backgroundSize: '196px 480px',
})

const image = style({
  borderRadius: '24px',
})

const image1 = style([
  image,
  {
    width: '166px',
    height: '166px',
    transformOrigin: 'bottom',
    transform: 'rotate(-5deg)',
  },
])

const image2 = style([
  image,
  {
    width: '160px',
    height: '201px',
    transformOrigin: 'center',
    transform: 'rotate(3deg)',
  },
])

const image3 = style([
  image,
  {
    width: '290px',
    height: '226px',
    transformOrigin: 'right',
    transform: 'rotate(-5deg)',
  },
])

const text = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const text2 = style([
  text,
  {
    maxWidth: '188px',
  },
])

const text3 = style([
  text,
  {
    maxWidth: '230px',
  },
])

const button = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  textDecoration: 'none',
  boxShadow: '0px 4px 8px 0px #5B5B5B29',
  padding: '8px 16px',
  borderRadius: '16px',
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
})

const caret = style({
  marginTop: '2px',
  width: '10px',
  height: '12px',
})

const dialogHeading1 = style({
  wordBreak: 'keep-all',
  textAlign: 'center',
  fontSize: '19px',
  fontWeight: '700',
})

const dialogHeading2 = style({
  fontSize: '16px',
  fontWeight: '700',
  padding: '0 24px'
})

const dialogDescription = style({
  fontSize: '15px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  whiteSpace: 'pre-wrap',
  padding: '0 24px'
})

const dialogBullet = style({
  fontSize: '15px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  listStyleType: 'numeric',
  padding: '0 0 0 40px'
})

export const styles = {
  section,
  content,
  image1,
  image2,
  image3,
  text,
  text2,
  text3,
  button,
  caret,
  dialogHeading1,
  dialogHeading2,
  dialogDescription,
  dialogBullet,
}
